import { FC } from 'react'
import { CoinsIcon } from 'shared/icons'
import { RadixColorType } from 'shared/types'

/** The accessible name of the demo coin. */
export const DEMO_COIN_LABEL = 'demo coins'

interface Props {
  className?: string
  size?: string
  color?: RadixColorType | 'black' | 'white'
}

/**
 * The coin of a virtual demo amount: a plain coin stack, neither the Tether
 * mark nor the XYRO token, so a demo stake never reads as real money. Takes
 * the props of `TetherToken`; the colour follows `color` or `currentColor`.
 */
export const DemoCoinIcon: FC<Props> = ({
  className,
  size = '2rem',
  color
}) => (
  <CoinsIcon
    role='img'
    aria-label={DEMO_COIN_LABEL}
    width={size}
    height={size}
    className={className}
    color={color ? `var(--${color})` : undefined}
  />
)
